import { TownsquareTagAri } from '@atlassian/ari';
import { TownsquareSiteAri } from '@atlassian/ari/townsquare/site';
import { getSiteId } from '@atlassian/projects-goals-common/get-site-id';
import { PreloadedQuery } from 'react-relay';

import { createRelayResource, type RelayResourceConfig } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';

import TagUpdatesFeedAggQuery, {
	type TagUpdatesFeedAggQuery as TagUpdatesFeedAggQueryType,
} from '../TagUpdatesView/agg/__generated__/TagUpdatesFeedAggQuery.graphql';

export const tagUpdatesAggResource: RouteResource<
	PreloadedQuery<TagUpdatesFeedAggQueryType, Record<string, unknown>>
> = createRelayResource<TagUpdatesFeedAggQueryType>({
	getQuery: (routerContext, resourceContext): RelayResourceConfig<TagUpdatesFeedAggQueryType> => {
		const { collabContext } = resourceContext as ResourceContext;
		const siteId = getSiteId('site', collabContext?.contextId ?? '');
		const tagUuid = routerContext?.match?.params.id ?? '';

		return {
			query: TagUpdatesFeedAggQuery,
			variables: {
				tagId: TownsquareTagAri.create({
					tagUuid,
					siteId,
				}).toString(),
				containerId: TownsquareSiteAri.create({ siteId }).toString(),
				shouldFetchUpdatesTabData: true,
			},
			environment: getAggRelayEnvironment(),
			options: {
				fetchPolicy: 'store-and-network',
			},
		};
	},
});
